import { BlockTitle } from "@blocks/Blocks";
import InternationalAward from "@e50/components/FAQ/components/InternationalAward";
import JudgingCommittee from "@e50/components/FAQ/components/JudgingCommittee";
import Partnership from "@e50/components/FAQ/components/Partnerships";
import Preference from "@e50/components/FAQ/components/Preference";
import Top50 from "@e50/components/FAQ/components/Top50";
import Turnover from "@e50/components/FAQ/components/Turnover";

/**
 * Component to E50 FAQ Page
 */
const E50FaqPage = (): React.ReactElement => {
  return (
    <div data-testid="e50-faq-page-component">
      <BlockTitle
        text="FAQ"
        rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-6 font-public-sans"
      />

      <div className="bg-gray-150 p-4">
        <p className="mb-2 font-public-sans text-xl font-medium">Questions</p>

        <JudgingCommittee />

        <Top50 />

        <Preference />

        <Partnership />

        <Turnover />

        <InternationalAward />
      </div>
    </div>
  );
};

export default E50FaqPage;
